module.exports = __webpack_public_path__ + "img/Active RA - Crown Icon.70244d7e.svg";